@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.core.devmenu.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.core.devmenu.resources/"

@delegate:ResourceContentHash(-996_347_185)
internal val Res.string.devmenu_build_debug: StringResource by lazy {
      StringResource("string:devmenu_build_debug", "devmenu_build_debug", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 35),
      ))
    }

@delegate:ResourceContentHash(-1_252_095_658)
internal val Res.string.devmenu_build_release: StringResource by lazy {
      StringResource("string:devmenu_build_release", "devmenu_build_release", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 70, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 46, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46, 41),
      ))
    }

@delegate:ResourceContentHash(1_254_615_316)
internal val Res.string.devmenu_build_type: StringResource by lazy {
      StringResource("string:devmenu_build_type", "devmenu_build_type", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 116, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 88, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 88, 42),
      ))
    }

@delegate:ResourceContentHash(1_255_322_555)
internal val Res.string.devmenu_env: StringResource by lazy {
      StringResource("string:devmenu_env", "devmenu_env", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 163, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 135, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 131, 47),
      ))
    }

@delegate:ResourceContentHash(-1_815_714_419)
internal val Res.string.devmenu_force_crash: StringResource by lazy {
      StringResource("string:devmenu_force_crash", "devmenu_force_crash", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 343, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 299, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 263, 51),
      ))
    }

@delegate:ResourceContentHash(1_320_452_050)
internal val Res.string.devmenu_force_crash_sub: StringResource by lazy {
      StringResource("string:devmenu_force_crash_sub", "devmenu_force_crash_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 215, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 187, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 179, 83),
      ))
    }

@delegate:ResourceContentHash(-765_918_381)
internal val Res.string.devmenu_no_tools: StringResource by lazy {
      StringResource("string:devmenu_no_tools", "devmenu_no_tools", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 423, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 363, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 315, 64),
      ))
    }

@delegate:ResourceContentHash(246_322_458)
internal val Res.string.devmenu_note: StringResource by lazy {
      StringResource("string:devmenu_note", "devmenu_note", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 520, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 448, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 380, 84),
      ))
    }

@delegate:ResourceContentHash(-1_387_464_395)
internal val Res.string.devmenu_section_diagnostics: StringResource by lazy {
      StringResource("string:devmenu_section_diagnostics", "devmenu_section_diagnostics", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 677, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 565, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 465, 51),
      ))
    }

@delegate:ResourceContentHash(1_959_800_247)
internal val Res.string.devmenu_section_tools: StringResource by lazy {
      StringResource("string:devmenu_section_tools", "devmenu_section_tools", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 737, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 617, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 517, 37),
      ))
    }

@delegate:ResourceContentHash(-1_536_999_599)
internal val Res.string.devmenu_version: StringResource by lazy {
      StringResource("string:devmenu_version", "devmenu_version", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 787, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 655, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 555, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("devmenu_build_debug", Res.string.devmenu_build_debug)
  map.put("devmenu_build_release", Res.string.devmenu_build_release)
  map.put("devmenu_build_type", Res.string.devmenu_build_type)
  map.put("devmenu_env", Res.string.devmenu_env)
  map.put("devmenu_force_crash", Res.string.devmenu_force_crash)
  map.put("devmenu_force_crash_sub", Res.string.devmenu_force_crash_sub)
  map.put("devmenu_no_tools", Res.string.devmenu_no_tools)
  map.put("devmenu_note", Res.string.devmenu_note)
  map.put("devmenu_section_diagnostics", Res.string.devmenu_section_diagnostics)
  map.put("devmenu_section_tools", Res.string.devmenu_section_tools)
  map.put("devmenu_version", Res.string.devmenu_version)
}
